// Manuka Egypt - Theme JavaScript

// Cart functionality
const ManukaCart = {
  async getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  },

  async addItem(variantId, quantity = 1, properties = {}) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity, properties })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Could not add item to cart');
    return data;
  },

  async updateItem(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    return res.json();
  },

  async removeItem(key) {
    return this.updateItem(key, 0);
  },

  formatMoney(cents) {
    return (cents / 100).toFixed(2);
  }
};

// Toast notifications
function showToast(message, type = 'success') {
  const existing = document.querySelector('.flash-message');
  if (existing) existing.remove();

  const toast = document.createElement('div');
  toast.className = `flash-message ${type}`;
  toast.textContent = message;
  document.body.appendChild(toast);

  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateX(100%)';
    toast.style.transition = '0.3s ease';
    setTimeout(() => toast.remove(), 300);
  }, 3000);
}

// Robust scroll lock (works on iOS Safari, restores scroll position on close)
let __fsScrollY = 0;
function fsLockScroll() {
  __fsScrollY = window.scrollY || document.documentElement.scrollTop || 0;
  const b = document.body.style;
  b.position = 'fixed'; b.top = `-${__fsScrollY}px`;
  b.left = '0'; b.right = '0'; b.width = '100%'; b.overflow = 'hidden';
}
function fsUnlockScroll() {
  const b = document.body.style;
  b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = ''; b.overflow = '';
  window.scrollTo(0, __fsScrollY);
}

// Cart drawer
class CartDrawer {
  constructor() {
    this.drawer = document.getElementById('cart-drawer');
    this.overlay = document.getElementById('cart-overlay');
    this.count = document.querySelectorAll('.cart-count');

    document.querySelectorAll('[data-open-cart]').forEach(btn => {
      btn.addEventListener('click', () => this.open());
    });
    this.overlay?.addEventListener('click', () => this.close());
    document.getElementById('cart-close')?.addEventListener('click', () => this.close());
    document.getElementById('continue-shopping-btn')?.addEventListener('click', () => this.close());
  }

  open() {
    this.drawer?.classList.add('is-open');
    this.overlay?.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    this.refresh();
  }

  close() {
    this.drawer?.classList.remove('is-open');
    this.overlay?.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  async refresh() {
    const cart = await ManukaCart.getCart();
    this.renderItems(cart);
    this.updateCount(cart.item_count);
    this.updateFreeShipping(cart);
  }

  updateFreeShipping(cart) {
    const bar = document.getElementById('free-shipping-bar');
    const text = document.getElementById('fsb-text');
    const fill = document.getElementById('fsb-fill');
    if (!bar || !text || !fill) return;

    // Hide if cart empty
    if (!cart.items || cart.items.length === 0) {
      bar.style.display = 'none';
      return;
    }

    const threshold = (window.ManukaConfig && window.ManukaConfig.freeShippingThreshold) || 500000;
    const subtotal = cart.total_price; // in cents
    const remaining = threshold - subtotal;
    const percent = Math.min(100, Math.max(0, (subtotal / threshold) * 100));

    bar.style.display = 'block';
    fill.style.width = percent + '%';

    if (remaining <= 0) {
      bar.classList.add('is-qualified');
      text.innerHTML = "<strong>You qualify for FREE shipping!</strong>";
    } else {
      bar.classList.remove('is-qualified');
      const remainingEgp = (remaining / 100).toLocaleString('en-US', { maximumFractionDigits: 0 });
      text.innerHTML = `Add <strong>EGP ${remainingEgp}</strong> more for <strong>FREE shipping</strong> Egypt-wide`;
    }
  }

  updateCount(count) {
    this.count.forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  renderItems(cart) {
    const body = document.getElementById('cart-items');
    const footer = document.getElementById('cart-footer');
    const reviews = document.querySelector('#cart-scroll .fs-cart-reviews');
    if (!body) return;

    if (cart.items.length === 0) {
      body.innerHTML = `
        <div class="cart-empty">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
            <path d="M1 1h4l2.68 13.39a2 2 0 001.99 1.61h9.72a2 2 0 001.99-1.61L23 6H6"/>
          </svg>
          <p>Your cart is empty</p>
          <a href="/collections/all" class="btn btn-primary btn-sm" onclick="document.getElementById('cart-drawer').classList.remove('is-open')">Shop Now</a>
        </div>`;
      if (footer) footer.style.display = 'none';
      if (reviews) reviews.style.display = 'none';
      return;
    }

    if (footer) footer.style.display = 'block';

    if (reviews) reviews.style.display = '';
    body.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <a href="${item.url}" class="cart-item__image">
          <img src="${item.image}" alt="${item.product_title}" width="80" height="80">
        </a>
        <div class="cart-item__details">
          <a href="${item.url}" class="cart-item__title">${item.product_title}</a>
          ${item.variant_title !== 'Default Title' ? `<p class="cart-item__variant">${item.variant_title}</p>` : ''}
          <div class="cart-item__bottom">
            <div class="quantity-selector quantity-selector--sm">
              <button type="button" onclick="cartDrawer.changeQty('${item.key}', ${item.quantity - 1})">−</button>
              <input type="number" value="${item.quantity}" min="0"
                onchange="cartDrawer.changeQty('${item.key}', parseInt(this.value))">
              <button type="button" onclick="cartDrawer.changeQty('${item.key}', ${item.quantity + 1})">+</button>
            </div>
            <span class="cart-item__price">${item.original_line_price > item.line_price ? `<span class="cart-item__price-was">EGP ${ManukaCart.formatMoney(item.original_line_price)}</span> ` : ''}EGP ${ManukaCart.formatMoney(item.line_price)}</span>
          </div>
        </div>
        <button class="cart-item__remove" onclick="cartDrawer.removeItem('${item.key}')" aria-label="Remove">×</button>
      </div>`).join('');

    const totalEl = document.getElementById('cart-total');
    if (totalEl) totalEl.textContent = `EGP ${ManukaCart.formatMoney(cart.total_price)}`;

    // Volume / automatic discount display in the drawer (was → now + savings line)
    const savings = cart.total_discount || 0;
    const wasEl = document.getElementById('cart-original-total');
    const discRow = document.getElementById('cart-discount-row');
    if (savings > 0) {
      if (wasEl) { wasEl.textContent = `EGP ${ManukaCart.formatMoney(cart.original_total_price)}`; wasEl.style.display = ''; }
      if (discRow) {
        const titles = [];
        cart.items.forEach(it => (it.discounts || []).forEach(d => { if (titles.indexOf(d.title) === -1) titles.push(d.title); }));
        const lbl = document.getElementById('cart-discount-label');
        const amt = document.getElementById('cart-discount-amount');
        if (lbl) lbl.textContent = titles.length ? titles.join(', ') : 'Discount';
        if (amt) amt.textContent = `− EGP ${ManukaCart.formatMoney(savings)}`;
        discRow.style.display = 'flex';
      }
    } else {
      if (wasEl) wasEl.style.display = 'none';
      if (discRow) discRow.style.display = 'none';
    }
  }

  async changeQty(key, qty) {
    await ManukaCart.updateItem(key, qty);
    this.refresh();
  }

  async removeItem(key) {
    await ManukaCart.removeItem(key);
    this.refresh();
    showToast('Item removed from cart');
  }
}

// ─── Wishlist ───
const ManukaWishlist = {
  KEY: 'manuka_wishlist_v1',

  get() {
    try {
      const data = JSON.parse(localStorage.getItem(this.KEY)) || [];
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  },

  set(list) {
    try {
      localStorage.setItem(this.KEY, JSON.stringify(list));
    } catch (e) {}
    this.updateUI();
  },

  has(handle) {
    return this.get().some(item => item.handle === handle);
  },

  add(item) {
    if (!item.handle) return;
    const list = this.get();
    if (list.some(i => i.handle === item.handle)) return;
    list.unshift(item);
    this.set(list);
  },

  remove(handle) {
    this.set(this.get().filter(i => i.handle !== handle));
  },

  toggle(item) {
    if (this.has(item.handle)) {
      this.remove(item.handle);
      return false;
    }
    this.add(item);
    return true;
  },

  updateUI() {
    const list = this.get();
    // Header count badge
    document.querySelectorAll('.wishlist-count').forEach(el => {
      el.textContent = list.length;
      el.classList.toggle('has-items', list.length > 0);
    });
    // Hearts on product cards
    document.querySelectorAll('.product-card').forEach(card => {
      const handle = card.dataset.productHandle;
      const btn = card.querySelector('[data-wishlist-btn]');
      if (btn && handle) {
        btn.classList.toggle('is-active', this.has(handle));
        btn.setAttribute('aria-label', this.has(handle) ? 'Remove from wishlist' : 'Add to wishlist');
      }
    });
    // Product page wishlist button
    document.querySelectorAll('[data-product-wishlist-btn]').forEach(btn => {
      const handle = btn.dataset.handle;
      if (handle) {
        const active = this.has(handle);
        btn.classList.toggle('is-active', active);
        const label = btn.querySelector('[data-wishlist-label]');
        if (label) label.textContent = active ? 'Saved' : 'Add to Wishlist';
      }
    });
    // Drawer items
    this.renderDrawer();
  },

  renderDrawer() {
    const container = document.getElementById('wishlist-items');
    if (!container) return;
    const list = this.get();

    if (list.length === 0) {
      container.innerHTML = `
        <div class="wishlist-empty">
          <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>
          </svg>
          <p>Your wishlist is empty</p>
          <a href="/collections/all" class="btn btn-primary btn-sm" onclick="document.getElementById('wishlist-drawer').classList.remove('is-open');document.getElementById('cart-overlay').classList.remove('is-visible');document.body.style.overflow='';">Browse Products</a>
        </div>`;
      return;
    }

    container.innerHTML = list.map(item => `
      <div class="wishlist-item" data-wl-handle="${item.handle}">
        <a href="${item.url}" class="wishlist-item__image">
          ${item.image ? `<img src="${item.image}" alt="${item.title.replace(/"/g, '&quot;')}" loading="lazy">` : ''}
        </a>
        <div class="wishlist-item__details">
          <a href="${item.url}" class="wishlist-item__title">${item.title}</a>
          <span class="wishlist-item__price">${wishlistMoney(item.price)}</span>
          <div class="wishlist-item__actions">
            <button type="button" class="wishlist-item__add"
                    onclick="wishlistDrawer.addToCart('${item.handle}', ${item.variantId})">
              Add to Cart
            </button>
            <button type="button" class="wishlist-item__remove"
                    onclick="ManukaWishlist.remove('${item.handle}')"
                    aria-label="Remove from wishlist">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
        </div>
      </div>
    `).join('');
  }
};

// Wishlist-specific money formatter (whole numbers, comma thousand sep)
function wishlistMoney(cents) {
  return 'EGP ' + (cents / 100).toLocaleString('en-US', { maximumFractionDigits: 0 });
}

// Global helper called from product card heart click
function toggleWishlist(card) {
  if (!card) return;
  const item = {
    handle: card.dataset.productHandle,
    title: card.dataset.productTitle,
    url: card.dataset.productUrl,
    image: card.dataset.productImage,
    price: parseInt(card.dataset.productPrice, 10) || 0,
    variantId: parseInt(card.dataset.productVariantId, 10) || 0,
    currency: 'EGP'
  };
  const added = ManukaWishlist.toggle(item);
  if (typeof showToast === 'function') {
    showToast(added ? 'Added to wishlist' : 'Removed from wishlist');
  }
}

// Wishlist Drawer controller
class WishlistDrawer {
  constructor() {
    this.drawer = document.getElementById('wishlist-drawer');
    this.overlay = document.getElementById('cart-overlay'); // reuse existing overlay
    this.openBtns = document.querySelectorAll('[data-open-wishlist]');

    this.openBtns.forEach(btn => btn.addEventListener('click', () => this.open()));
    document.getElementById('wishlist-close')?.addEventListener('click', () => this.close());
  }

  open() {
    if (typeof cartDrawer !== 'undefined' && cartDrawer.drawer && cartDrawer.drawer.classList.contains('is-open')) {
      cartDrawer.close();
    }
    this.drawer?.classList.add('is-open');
    this.overlay?.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    ManukaWishlist.renderDrawer();

    // Wire overlay click to close (one-time)
    if (!this._overlayWired) {
      this.overlay?.addEventListener('click', () => {
        if (this.drawer?.classList.contains('is-open')) this.close();
      });
      this._overlayWired = true;
    }
  }

  close() {
    this.drawer?.classList.remove('is-open');
    this.overlay?.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  async addToCart(handle, variantId) {
    if (!variantId) {
      // Redirect to product page if no default variant
      window.location.href = '/products/' + handle;
      return;
    }
    try {
      await ManukaCart.addItem(variantId, 1);
      ManukaWishlist.remove(handle);
      showToast('Moved to cart!');
      this.close();
      cartDrawer.open();
    } catch (e) {
      showToast('Could not add to cart. Please try again.', 'error');
    }
  }
}

// Mobile menu
class MobileMenu {
  constructor() {
    this.menu = document.getElementById('mobile-menu');
    this.toggle = document.getElementById('menu-toggle');
    this.close = document.getElementById('menu-close');
    this.overlay = document.getElementById('menu-overlay');
    this.header = document.getElementById('site-header');

    this.toggle?.addEventListener('click', () => this.toggleMenu());
    this.close?.addEventListener('click', () => this.closeMenu());
    this.overlay?.addEventListener('click', () => this.closeMenu());
  }

  toggleMenu() {
    if (this.menu?.classList.contains('is-open')) this.closeMenu();
    else this.open();
  }

  open() {
    // Hide the announcement bar first (via body.menu-open) so the sticky header
    // sits at the very top, THEN measure the header's bottom edge so the panel
    // sits flush beneath the logo/search/cart bar with no gap that would reveal
    // the hero behind it. Re-measure on the next frame (after the announcement
    // bar is removed from layout) for an exact fit, and also handle shrink-on-scroll.
    document.body.classList.add('menu-open');
    const pin = () => {
      const h = this.header ? Math.max(0, Math.round(this.header.getBoundingClientRect().bottom)) : 0;
      if (h && this.menu) {
        this.menu.style.top = h + 'px';
        this.menu.style.height = 'calc(100dvh - ' + h + 'px)';
        if (this.overlay) this.overlay.style.top = h + 'px';
      }
    };
    pin();
    requestAnimationFrame(pin);
    this.menu?.classList.add('is-open');
    this.overlay?.classList.add('is-visible');
    this.toggle?.classList.add('is-open');
    this.toggle?.setAttribute('aria-expanded', 'true');
    // Lock scroll on the real scroll container (html) too — body alone does NOT
    // reliably stop the page from scrolling on mobile, which would let the sticky
    // header scroll away and leave a gap above the fixed menu.
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  closeMenu() {
    document.body.classList.remove('menu-open');
    this.menu?.classList.remove('is-open');
    this.overlay?.classList.remove('is-visible');
    this.toggle?.classList.remove('is-open');
    this.toggle?.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }
}

// Sticky header
function initStickyHeader() {
  const header = document.getElementById('site-header');
  if (!header) return;

  window.addEventListener('scroll', () => {
    header.classList.toggle('is-scrolled', window.scrollY > 50);
  }, { passive: true });
}

// Quantity buttons on product page
function initQuantityButtons() {
  document.querySelectorAll('.quantity-selector').forEach(selector => {
    const input = selector.querySelector('input');
    selector.querySelector('[data-minus]')?.addEventListener('click', () => {
      const val = parseInt(input.value) - 1;
      if (val >= parseInt(input.min || 1)) input.value = val;
    });
    selector.querySelector('[data-plus]')?.addEventListener('click', () => {
      input.value = parseInt(input.value) + 1;
    });
  });
}

// Add to cart form
function initAddToCart() {
  document.querySelectorAll('[data-add-to-cart-form]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const variantId = form.querySelector('[name="id"]')?.value;
      const qty = parseInt(form.querySelector('[name="quantity"]')?.value || 1);

      if (!variantId) return;

      btn.disabled = true;
      btn.textContent = 'Adding...';

      try {
        await ManukaCart.addItem(variantId, qty);
        showToast('Added to cart!');
        cartDrawer.open();
      } catch (err) {
        showToast(err.message || 'Could not add item. Please try again.', 'error');
      } finally {
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      }
    });
  });
}

// Image gallery on product page
function initProductGallery() {
  const thumbnails = document.querySelectorAll('[data-thumbnail]');
  const mainImage = document.querySelector('[data-main-image]');

  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbnails.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImage) {
        mainImage.src = thumb.dataset.src;
        mainImage.srcset = '';
      }
    });
  });
}

// Search overlay
function initSearch() {
  const overlay = document.getElementById('search-overlay');
  const input = document.getElementById('search-input');

  document.querySelectorAll('[data-open-search]').forEach(btn => {
    btn.addEventListener('click', () => {
      overlay?.classList.add('is-open');
      setTimeout(() => input?.focus(), 100);
    });
  });

  document.getElementById('search-close')?.addEventListener('click', () => {
    overlay?.classList.remove('is-open');
  });

  overlay?.addEventListener('click', (e) => {
    if (e.target === overlay) overlay.classList.remove('is-open');
  });
}

// Variant selector
function initVariantSelector() {
  const form = document.querySelector('[data-product-form]');
  if (!form) return;

  const variantData = window.productVariants;
  if (!variantData || !variantData.length) return;

  const priceEl        = document.querySelector('[data-product-price]');
  const comparePriceEl = document.querySelector('[data-compare-price]');
  const addToCartBtn   = form.querySelector('[type="submit"]');
  const variantInput   = form.querySelector('[name="id"]');
  const stickyBtn      = document.getElementById('sticky-atc-btn');
  const stickyPrice    = document.getElementById('sticky-price');

  // Option buttons live OUTSIDE the form (sibling .product-info__options block) — query from document
  function getOptionGroups() {
    return document.querySelectorAll('.product-info__options .option-btns');
  }

  // Read selected options from active buttons (NOT from .value — these are <button> elements)
  function getSelectedOptions() {
    return Array.from(getOptionGroups()).map(group => {
      const active = group.querySelector('.option-btn.active');
      return active ? active.textContent.trim() : null;
    });
  }

  function findVariant(options) {
    return variantData.find(v =>
      v.options.every((opt, i) => opt === options[i])
    );
  }

  function markSoldOutCombos(options) {
    getOptionGroups().forEach((group, gIdx) => {
      group.querySelectorAll('.option-btn').forEach(btn => {
        const testOpts = [...options];
        testOpts[gIdx] = btn.textContent.trim();
        const v = findVariant(testOpts);
        btn.classList.toggle('sold-out', !v || !v.available);
      });
    });
  }

  function updateVariant() {
    const options = getSelectedOptions();

    // Default-variant product (no option buttons rendered) — trust the server-rendered state and bail
    if (options.length === 0) return;

    const variant = findVariant(options);

    markSoldOutCombos(options);

    if (!variant) {
      if (variantInput) variantInput.value = '';
      if (addToCartBtn) { addToCartBtn.disabled = true; addToCartBtn.textContent = 'Not Available'; }
      if (stickyBtn)    { stickyBtn.disabled = true; }
      return;
    }

    // Update hidden variant ID input
    if (variantInput) variantInput.value = variant.id;

    // Update price
    const price = 'EGP ' + ManukaCart.formatMoney(variant.price);
    if (priceEl)     priceEl.textContent    = price;
    if (stickyPrice) stickyPrice.textContent = price;

    // Update compare price
    if (comparePriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.textContent   = 'EGP ' + ManukaCart.formatMoney(variant.compare_at_price);
        comparePriceEl.style.display = 'inline';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }

    // Update ATC button state
    const available = variant.available;
    if (addToCartBtn) {
      addToCartBtn.disabled    = !available;
      addToCartBtn.textContent = available ? (addToCartBtn.dataset.preorder === 'true' ? 'Pre-Order' : 'Add to Cart') : 'Sold Out';    }
    if (stickyBtn) {
      stickyBtn.disabled = !available;
    }
  }

  // Event delegation on form — fires after inline onclick updates active class
  form.addEventListener('click', function(e) {
    if (e.target.classList.contains('option-btn') && !e.target.classList.contains('sold-out')) {
      setTimeout(updateVariant, 0);
    }
  });

  // Sync on page load
  updateVariant();
}

// Countdown timer (for promotions)
function initCountdown() {
  document.querySelectorAll('[data-countdown]').forEach(el => {
    const endTime = new Date(el.dataset.countdown).getTime();

    function tick() {
      const now = Date.now();
      const diff = endTime - now;

      if (diff <= 0) {
        el.innerHTML = '<span>Offer ended</span>';
        return;
      }

      const days = Math.floor(diff / 86400000);
      const hrs = Math.floor((diff % 86400000) / 3600000);
      const mins = Math.floor((diff % 3600000) / 60000);
      const secs = Math.floor((diff % 60000) / 1000);

      el.querySelector('[data-days]').textContent = String(days).padStart(2, '0');
      el.querySelector('[data-hours]').textContent = String(hrs).padStart(2, '0');
      el.querySelector('[data-minutes]').textContent = String(mins).padStart(2, '0');
      el.querySelector('[data-seconds]').textContent = String(secs).padStart(2, '0');
    }

    tick();
    setInterval(tick, 1000);
  });
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  window.cartDrawer = new CartDrawer();
  window.wishlistDrawer = new WishlistDrawer();
  new MobileMenu();
  initStickyHeader();
  initQuantityButtons();
  initAddToCart();
  initProductGallery();
  initSearch();
  initVariantSelector();
  initCountdown();
  // Initial wishlist UI sync (header count, card hearts)
  ManukaWishlist.updateUI();
});
